import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bookview scroll" }
const _hoisted_2 = { class: "topbar" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = { class: "selectionbar" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "homebutton",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "gg-close" }, null, -1),
        _createElementVNode("div", null, "Cancel", -1)
      ])),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.item?.Name ?? 'Acvitity does not exist'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.string,
          class: _normalizeClass({ selected: _ctx.step == item.type, inactive: !_ctx.canAccess(item.type), item: true }),
          onClick: ($event: any) => (_ctx.navTo(item.type))
        }, _toDisplayString(item.string), 11, _hoisted_5))
      }), 128))
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_router_view)
    ])
  ]))
}